import React, { FC, memo } from 'react'

import { Outlet } from 'react-router-dom'

import { useAuth } from '@sportworld/js-sdk/src/context/authContext'
import { isDevMode } from '@sportworld/js-sdk/src/envs/envs'

import { Loader } from '@/components/Loader'
import { MainSidebar } from '@/components/MainSidebar/MainSidebar'
import { focusIds } from '@/constants/focus'
import { logStartupTime } from '@/utils/utils'

import { Container } from '../styles'

isDevMode && logStartupTime()

const MainLayoutRaw: FC = () => {
  const { isAuthenticatedUserType } = useAuth()

  return isAuthenticatedUserType ? (
    <>
      <MainSidebar />
      <Container focusId={focusIds.CONTENT} elementType="main">
        <Outlet />
      </Container>
    </>
  ) : (
    <Loader />
  )
}

export const MainLayout = memo(MainLayoutRaw)
